/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
const DGEDashboardCountER = ({ ...props }) => {
    const [Count, setCount] = useState(0);
   


    const getdata = async () => {
        const sendData = {
            YearId: Number(props.year),
            MonthId: Number(props.month),
            Month: String(props.catgtype),
        }
        /*//console.log(sendData)*/
        
        await fetch(process.env.REACT_APP_API_LINK +'api/ER/'+props.api, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                   /* //console.log(data)*/
                    setCount(data)
                })


    };

    useEffect(() => {
        getdata()
    }, [])


    return (
        <>
                <td> <b style={{ fontSize: 18 }}>{Count.eex}</b></td>
                <td> <b style={{ fontSize: 18 }}>{Count.total}</b></td>
            <td> <b style={{ fontSize: 18 }}>{Count.open}</b></td>
            <td> <b style={{ fontSize: 18 }}>{Count.edit}</b></td>
            <td> <b style={{ fontSize: 18 }}>{Count.submit}</b></td> 
             
            </>
    )  
};

export default DGEDashboardCountER;
